module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-container"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-52eab061!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/material/components/plCard/plCard.vue
// module id = 2354
// module chunks = 61